import {
  BrandKit,
  ButtonHierarchy,
  ButtonOptionsOverride,
} from "@redotech/redo-model/brand-kit";
import { fontWeightValues } from "@redotech/redo-model/signup-form";
import * as classNames from "classnames";
import { memo } from "react";
import {
  RedoButton,
  RedoButtonHierarchy,
  RedoButtonProps,
} from "./arbiter-components/buttons/redo-button";
import * as css from "./brand-kit-button.module.css";

const hierarchyLiteralToEnum: Record<string, RedoButtonHierarchy> = {
  primary: RedoButtonHierarchy.PRIMARY,
  secondary: RedoButtonHierarchy.SECONDARY,
  // tertiary buttons are intentionally not included here
} as const;

export const BrandKitButton = memo(function BrandKitButton({
  brandKit,
  override,
  hierarchy,
  ...props
}: Omit<RedoButtonProps, "hierarchy" | "style"> & {
  brandKit: BrandKit;
  override?: ButtonOptionsOverride;
  hierarchy: ButtonHierarchy;
}) {
  const style = getButtonStyles(brandKit, hierarchy, override);
  return (
    <RedoButton
      className={classNames(props.className, css.brandKitButton)}
      dangerousStyleThatShouldOnlyBeUsedForMerchantBranding={style}
      hierarchy={hierarchyLiteralToEnum[hierarchy]}
      {...props}
    />
  );
});

function getButtonStyles(
  brandKit: BrandKit,
  hierarchy: ButtonHierarchy,
  override?: ButtonOptionsOverride,
): React.CSSProperties {
  const styles = override ? override[hierarchy] : brandKit?.buttons[hierarchy];
  return {
    backgroundColor: styles.backgroundColor,
    color: styles.textColor,
    border: `${styles.border.stroke.weightPx}px solid ${styles.border.stroke.color}`,
    borderRadius: `${styles.border.cornerRadiusPx}px`,
    width: "100%",
    fontFamily:
      "fontReference" in styles
        ? brandKit?.font.fontFamily
        : styles.font.fontFamily,
    fontSize: `${"fontReference" in styles ? brandKit?.font.hierarchy[styles.fontReference].fontSizePx : styles.font.fontSizePx}px`,
    fontWeight:
      fontWeightValues[
        "fontReference" in styles
          ? brandKit?.font.hierarchy[styles.fontReference].fontWeight
          : styles.font.fontWeight
      ],
    padding: `${styles.paddingPx}px`,
  };
}
